<template>
  <content-layout>
    <form class="virtual-cards" @submit.prevent="sendOrder">
      <header class="header">
        <div class="container">
          <div class="title">Покупка электронной карты</div>
          <!--
          <div class="info">Выберите город, куда вы хотите отправить карту</div>
          <div class="city-select" :class="{'invalid': $v.cityId.$error}">
            <select class="field select" name="city" @change="changeCity" v-model="cityId">
              <option value="">Выберите город</option>
              <option v-for="city in cities" :value="city.id">{{ city.title }}</option>
            </select>
            <div class="info notice with-icon">Карта/карты будут действовать только в этом городе</div>
          </div>
          -->
        </div>
        <router-link :to="{ name: 'SelectType' }" class="go-back content-box-component">закрыть</router-link>
      </header>

      <div class="content">
        <template v-for="(selectedCard, index) in items">
          <section
            v-if="card !== selectedCard"
            @click.stop="editCard(selectedCard)"
            class="card order"
            :data-number="index + 1 + '.'"
            :key="`selectedCard_section_${index}`"
          >
            <button class="remove" type="button" @click.prevent.stop="remove(selectedCard, index)"> удалить <i class="close-button"></i></button>
            <img :src="selectedCard.design">
            <p class="info">
              <span class="first-line"><b>{{ selectedCard.recipient.name }}</b>, карта на <b>{{ selectedCard.amount }} руб.</b></span><br>
              <span v-if="selectedCard.recipient.email">{{ selectedCard.recipient.email }}<br></span>
              {{ selectedCard.recipient.phone }}<br>
              получение карты {{ selectedCard.sendingDate | dateFormat(selectedCard.sendingHour) }}
              ({{ getTimeZoneRepresentation(selectedCard.sendingTimezone)}})
            </p>
          </section>
          <form
            ref="form"
            class="card-form"
            v-if="card === selectedCard"
            @submit.prevent="addCard"
            :key="`selectedCard_form_${index}`"
          >
            <section class="contacts recipient" :data-number="index + 1 + '.'">
              <h3 class="heading">Данные получателя карты</h3>
              <span class="input input--chisato" :class="{ 'input--filled': !!card.recipient.name, 'invalid': $v.card.recipient.name.$error }">
                <input class="field input__field input__field--chisato" id="recipient-name" @input="$v.card.recipient.name.$touch()" type="text" v-model="card.recipient.name" >
                <label class="input__label input__label--chisato" for="recipient-name">
                  <span class="input__label-content input__label-content--chisato" data-content="Имя Фамилия">Имя Фамилия</span>
                </label>
              </span><br>
              <span class="input input--chisato" :class="{ 'input--filled': !!card.recipient.phone, 'invalid': $v.card.recipient.phone.$error }">
                <masked-input
                      @input="$v.card.recipient.phone.$touch()"
                      class="field input__field input__field--chisato"
                      v-model="card.recipient.phone" mask="\+\375 (11) 111 11 11"
                      id="recipient-phone"
                />
                <label class="input__label input__label--chisato" for="recipient-phone">
                  <span class="input__label-content input__label-content--chisato" data-content="Телефон">+375 (__) ___ __ __</span>
                </label>
                <span class="code">+375</span>
              </span><br>
              <span class="input input_not-required input--chisato" :class="{ 'input--filled': !!card.recipient.email, 'invalid-email': $v.card.recipient.email.$error }">
                <input class="field input__field input__field--chisato"
                       id="recipient-email" type="email"
                       v-model.trim="card.recipient.email"
                       @input="$v.card.recipient.email.$touch()">
                <label class="input__label input__label--chisato" for="recipient-email">
                  <span class="input__label-content input__label-content--chisato" data-content="E-mail">E-mail</span>
                </label>
              </span>
            </section>
            <section class="dark amount">
              <h3 class="heading">Укажите номинал карты</h3>
              <span class="input card-amount" :class="{'invalid': $v.card.amount.$error}">
                <input
                  class="field short"
                  type="number"
                  v-model="card.amount"
                  :placeholder="minCost + '–' + maxCost"
                  :min="minCost"
                  :max="maxCost"
                  @input="$v.card.amount.$touch()"
                  @keypress="onSumKeyPress"
                >
                <div class="amount-error" v-if="$v.card.amount.$error && card.amount < minCost && card.amount">Стоимость карты должна быть не менее {{ minCost | costFormat }} руб.</div>
                <div class="amount-error" v-if="$v.card.amount.$error && card.amount > maxCost">Стоимость карты должна быть не более {{ maxCost | costFormat }} руб.</div>
                <div class="amount-error" v-if="$v.card.amount.$error && !card.amount">Пожалуйста, заполните это поле</div>
                <div class="notice with-icon">
                  Вы можете ввести любую сумму<br>от {{ minCost | costFormat }} руб. до {{ maxCost | costFormat }} руб.
                </div>
              </span>
            </section>
            <section class="dashed dark" :class="{'virtual-mobile': isMobile}">
              <h3 class="heading">Выберите дизайн карты</h3>
              <swiper v-if="isMobile" :options="swiperOptions">
                <swiper-slide v-for="(design, item) in designs" :key="`slide_${design.path}`">
                  <label class="card">
                    <input class="radio" type="radio" name="desing" v-model="card.design" :value="design.path">
                    <img :src="design.path">
                    <div class="counter">{{ item + 1 }} <small>из</small> {{ designs.length }}</div>
                  </label>
                </swiper-slide>
              </swiper>
              <div class="range" v-else>
                <label v-for="(design, item) in designs" class="card" :key="`label_${design.path}`">
                  <input class="radio" type="radio" name="desing" v-model="card.design" :value="design.path">
                  <img :src="design.path">
                  <div class="counter">{{ item + 1 }} <small>из</small> {{ designs.length }}</div>
                </label>
              </div>
            </section>
            <section class="congratulation dashed dark">
              <h3 class="heading">Добавьте текст поздравления</h3>
              <span class="input input_not-required input--chisato full-width card-text" :class="{ 'input--filled': !!card.text, 'invalid': $v.card.text.$error }">
                <textarea class="field input__field input__field--chisato" id="card-text" v-model="card.text" @input="$v.card.text.$touch()"/>
                <label class="input__label input__label--chisato" for="card-text">
                  <span class="input__label-content input__label-content--chisato" data-content="Текст послания">Текст послания</span>
                </label>
              </span>
              <div class="row">
                <div class="col col-sign">
                  <span class="input input--chisato" :class="{ 'input--filled': !!card.senderSign, 'invalid': $v.card.senderSign.$error }">
                    <input class="field input__field input__field--chisato" id="sender-sign" type="text" v-model="card.senderSign" :disabled="card.anonymous" @input="$v.card.senderSign.$touch()" >
                    <label class="input__label input__label--chisato" for="sender-sign">
                      <span class="input__label-content input__label-content--chisato" data-content="От кого / подпись">От кого / подпись</span>
                    </label>
                  </span><br>
                  <label class="checkbox">
                    <input type="checkbox" @change="toggleAnonymous" v-model="selectedCard.anonymous">
                    Отправить анонимно
                  </label>
                </div>
                <div class="col sending-datetime">
                  <span class="input input--chisato input--filled input_datapicker" :class="{'invalid': $v.card.sendingDate.$error}">
                    <!-- <input class="field input__field input__field--chisato" id="sending-date" type="date" :min="minDate" v-model="card.sendingDate" @input="$v.card.sendingDate.$touch()"> -->
                    <datepicker ref="datepicker" language="ru"
                                :monday-first="true"
                                :clear-button="true"
                                v-model="card.sendingDate"
                                :format="'dd/MM/yyyy'"
                                :disabled="datepickerDisabled"
                                @selected="$v.card.sendingDate.$touch()"
                                @cleared="card.sendingDate = ''"
                                wrapper-class="field input__field input__field--chisato"
                                input-class="custom-input"
                                id="sending-date"
                    />
                    <label class="input__label input__label--chisato" for="sending-date">
                      <span class="input__label-content input__label-content--chisato" data-content="Дата отправления">Дата отправления</span>
                    </label>
                  </span>
                  <span class="input input--chisato input--filled">
                    <select class="field select input__field input__field--chisato" id="sending-hour" v-model="card.sendingHour" required>
                      <option :key="index" v-for="(n, index) in allowHours" :value="n">{{ n | hourFormat }}</option>
                    </select>
                    <label class="input__label input__label--chisato" for="sending-hour">
                      <span class="input__label-content input__label-content--chisato" data-content="Время">Время</span>
                    </label>
                  </span>
                  <span class="input input--chisato input--filled select-timezone">
                    <select class="field select input__field input__field--chisato" id="sending-timezone" v-model="card.sendingTimezone" required>
                      <option v-for="(name, tz) in timezones" :key="tz" :value="tz">{{ name }}</option>
                    </select>
                    <label class="input__label input__label--chisato" for="sending-timezone">
                      <span class="input__label-content input__label-content--chisato" data-content="Часовой пояс">Часовой пояс</span>
                    </label>
                  </span>
                  <div class="notice">
                    Время, когда адресату будет отправлена<br>электронная подарочная карта
                  </div>
                </div>
              </div>
            </section>
          </form>
        </template>
        <section class="center add-wrapper">
          <button @click.prevent.stop="addCard" class="add"><big>+</big><small>&ensp;Добавить ещё карту</small></button>
        </section>
        <section class="contacts buyer center">
          <h3 class="heading">Контактные данные плательщика</h3>
          <span class="input input--chisato" :class="{ 'input--filled': !!buyer.name, 'invalid': $v.buyer.name.$error }">
            <input class="field input__field input__field--chisato" id="buyer-name" type="text" v-model="buyer.name" @input="$v.buyer.name.$touch()" >
            <label class="input__label input__label--chisato" for="buyer-name">
              <span class="input__label-content input__label-content--chisato" data-content="Имя Фамилия">Имя Фамилия</span>
            </label>
          </span><br>
          <span class="input input--chisato" :class="{ 'input--filled': !!buyer.email, 'invalid': $v.buyer.email.$error }">
            <input class="field input__field input__field--chisato" id="buyer-email" type="email" v-model.trim="buyer.email" @input="$v.buyer.email.$touch()" >
            <label class="input__label input__label--chisato" for="buyer-email">
              <span class="input__label-content input__label-content--chisato" data-content="E-mail">E-mail</span>
            </label>
          </span><br>
          <span class="input input--chisato" :class="{ 'input--filled': !!buyer.phone, 'invalid': $v.buyer.phone.$error }">
            <masked-input
                  v-model="buyer.phone"
                  @input="$v.buyer.phone.$touch()"
                  class="field input__field input__field--chisato"
                  mask="\+\375 (11) 111 11 11"
                  id="buyer-phone"
            />
            <label class="input__label input__label--chisato" for="buyer-phone">
              <span class="input__label-content input__label-content--chisato" data-content="Телефон">+375 (__) ___ __ __</span>
            </label>
            <span class="code">+375</span>
          </span>
        </section>
        <section class="subtotal dark">
          <table>
            <tr v-for="(selectedCard, index) in nonEmptyCards" :key="`total_${index}`">
              <td>{{index + 1}}. {{ selectedCard.recipient.name }}</td>
              <td class="cost">{{ selectedCard.amount | costFormat }} руб</td>
            </tr>
            <tr class="total">
              <td>ИТОГОВАЯ СУММА</td>
              <td class="cost">{{ total | costFormat }} руб</td>
            </tr>
            <tr>
              <label class="checkbox">
                <input type="checkbox" required>Я даю согласие на обработку моих персональных данных
              </label>
            </tr>
          </table>
          <div class="buy-buttons">
            <button @click.capture="e => setPaymentType(e)" class="buy" value="card" name="card" :disabled="!total || pending">{{ pending ? 'Подождите...' : 'Оплата картой'}}
            </button>
          </div>
          <div class="notice">
            Нажимая кнопку «Перейти к оплате»,<br>
            я соглашаюсь с
            <a href="/static/docs/Правила продажи и оборота подарочных карт.pdf" target="_blank" class="more">Офертой</a> и
            <a href="/static/docs/Политика обработки и хранения персональных данных.pdf" target="_blank" class="more">Политикой по персональным данным</a>
          </div>
        </section>
      </div>
    </form>
    <modal
      :height="modalHeight"
      :width="modalwidth"
      name="pay-by-sendy"
      @closed="pending = false"
    >
      <div class="result">
        <a class="go-back-modal content-box-component" @click="closeSendyModal"></a>
        <div class="top">
          <div class="title">Sendy Pay</div>
          <p class="message-modal">Для оплаты отсканируйте QR-код</p>
          <p class="message-modal">
            <qriously :value="sendyQRData" :size="200" />
          </p>
          <p class="message-modal">
            Ожидаем оплаты...
          </p>
        </div>
        <section class="subtotal">
          <div class="buy-buttons">
            <button
              @click="closeSendyModal"
              class="buy"
            >
              Отмена
            </button>
          </div>
        </section>
      </div>
    </modal>
  </content-layout>
</template>

<script>
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required, email, between, or } from 'vuelidate/lib/validators'

import { swiper, swiperSlide } from '@/components/Swiper/index.js'
import MaskedInput from 'vue-masked-input'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment-timezone'

import { apiUrl } from '@/config.js'
import { getTopPosition, phoneValid, emailOrTrue, textFieldValid } from '@/utils.js'
import ContentLayout from '@/components/ContentLayout.vue'
require('smoothscroll-polyfill').polyfill()

const now = new Date()
const yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
const today = {
  day: now.getDate(),
  month: now.getMonth() + 1,
  year: now.getFullYear()
}

function IsAnonymous () {
  return this.card.anonymous === true
}

const requiredIfPersonal = or(required, IsAnonymous)

const requiredDate = value => {
  if (value instanceof Date) {
    // invalid date won't pass
    return !isNaN(value.getTime())
  }
  if (typeof value === 'string') {
    // check if we abble to covert date
    try {
      return Date.parse(value)
    } catch (e) {
      return false
    }
  }
  return false
}

// const timezoneOffsets = {
//   'Europe/Moscow': -180,
//   'Europe/Kaliningrad': -120,
//   'Europe/Samara': -240,
//   'Asia/Yekaterinburg': -300,
//   'Asia/Omsk': -360,
//   'Asia/Krasnoyarsk': -400,
//   'Asia/Irkutsk': -460,
//   'Asia/Yakutsk': -520,
//   'Asia/Vladivostok': -600,
//   'Asia/Sakhalin': -660,
//   'Asia/Anadyr': -720
// }

const dateToTimezone = (date, timeZone, sHours) => {
  const d1 = moment(date)
    .tz(timeZone)
    .startOf('day')
    .hour(sHours)
    .toISOString()
  return d1
}

export default {
  name: 'virtual-cards',
  mixins: [validationMixin],
  data () {
    return {
      isMobile: false,
      pending: false,
      designs: [
        { path: '/static/img/vcards/card_1.png' },
        { path: '/static/img/vcards/card_2.png' },
        { path: '/static/img/vcards/card_3.png' },
        { path: '/static/img/vcards/card_4.png' },
        { path: '/static/img/vcards/card_5.png' },
        { path: '/static/img/vcards/card_6.png' },
        { path: '/static/img/vcards/card_7.png' },
        { path: '/static/img/vcards/card_8.png' },
        { path: '/static/img/vcards/card_9.png' },
        { path: '/static/img/vcards/card_10.png' },
        { path: '/static/img/vcards/card_11.png' },
        { path: '/static/img/vcards/card_12.png' }
      ],
      cities: [],
      cityId: '',
      card: null,
      items: [],
      buyer: {
        name: '',
        phone: '',
        email: ''
      },
      sendReceiptBySms: false,
      oldOrder: {},
      anonymous: false,
      minCost: 0,
      maxCost: 0,
      now: now,
      minDate: `${today.year}-${today.month.toString().length === 2 ? today.month : '0' + today.month}-${today.day.toString().length === 2 ? today.day : '0' + today.day}`,
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 24,
        centeredSlides: true
      },
      datepickerDisabled: {
        to: yesterday,
        from: new Date(today.year + 3, today.month - 1, today.day)
      },
      timezones: {
        'Europe/Minsk': 'Минск'
      },
      sendyTimerID: 0,
      sendyOrderStatus: '',
      sendyQRData: '',
      modalHeight: 'auto',
      modalwidth: '600px'
    }
  },
  validations () {
    return {
      cityId: {
        required
      },
      card: {
        recipient: {
          name: {
            required
          },
          phone: {
            phoneValid,
            required
          },
          email: {
            emailOrTrue
          }
        },
        text: {
          textFieldValid
        },
        amount: {
          required,
          between: this.minCost && this.maxCost ? between(this.minCost, this.maxCost) : required
        },
        senderSign: {
          requiredIfPersonal,
          textFieldValid
        },
        sendingDate: {
          requiredDate
        }
      },
      buyer: {
        name: {
          required
        },
        phone: {
          phoneValid,
          required
        },
        email: {
          required,
          email
        }
      },
      customer: ['buyer']
    }
  },
  components: {
    ContentLayout,
    swiper,
    swiperSlide,
    MaskedInput,
    Datepicker
  },
  computed: {
    total () {
      return this.nonEmptyCards.reduce((sum, card) => sum + parseInt(card.amount), 0)
    },
    sendingToday () {
      return new Date(this.card.sendingDate).toLocaleDateString() === new Date().toLocaleDateString()
    },
    isCardFormEmpty () {
      return this.isCardEmpty(this.card)
    },
    nonEmptyCards () {
      return this.items.filter(card => !this.isCardEmpty(card))
    },
    haveActiveCard () {
      return this.items.indexOf(this.card) !== -1
    },
    allowHours () {
      const sameDay = (d1, d2) => {
        let date1 = d1
        let date2 = d2
        // now convert to UTC
        if (typeof date1 === 'string') {
          date1 = new Date(Date.parse(date1))
        } else {
          date1 = new Date(date1.getTime())
        }
        if (typeof date2 === 'string') {
          date2 = new Date(Date.parse(date2))
        } else {
          date2 = new Date(date2.getTime())
        }
        date1.setHours(23, 59, 59, 999)
        date2.setHours(23, 59, 59, 999)
        return date1.getUTCFullYear() === date2.getUTCFullYear() &&
            date1.getUTCMonth() === date2.getUTCMonth() &&
            date1.getUTCDate() === date2.getUTCDate()
      }
      const result = []
      for (
        let i = sameDay(new Date(), this.card.sendingDate)
          ? new Date().getHours() + 1
          : 0; i < 24; i++
      ) {
        result.push(i)
      }
      if (result.length && this.card.sendingHour < result[0]) {
        this.$set(this.card, 'sendingHour', result[0])
      }
      return result
    }
  },
  created () {
    const card = this.makeEmptyCard()
    this.card = card
    this.card.sendingDate = new Date()
    this.items.push(card)

    axios.get(`${apiUrl}/cards`)
      .then(({ data }) => {
        this.cities = data.cities
        const firstCity = data.cities[0]
        this.minCost = firstCity.minVirtualCost
        this.maxCost = firstCity.maxVirtualCost
        // this.designs = data.allSpecials
        this.card.design = this.designs[0].path
        this.oldOrder = this.$localStorage.get('order')
        if (this.oldOrder && this.oldOrder.type === 'virtual') {
          this.cityId = this.oldOrder.cityId
          this.buyer = this.oldOrder.buyer
          this.items = this.oldOrder.items
          this.card = this.makeEmptyCard()
        }
      })
      .catch(console.error)
  },
  mounted () {
    window.addEventListener('resize', this.setIsMobile)
    this.setIsMobile()
    this.$v.card.$reset()
    this.$v.customer.$reset()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setIsMobile)
  },
  methods: {
    setPaymentType (e) {
      this.paymentType = e.target.name
    },
    onSumKeyPress (e) {
      if (e.key === '.' || e.key === ',') {
        e.preventDefault()
      }
    },
    getTimeZoneRepresentation (timezone) {
      return 'Минск'
    },
    setIsMobile () {
      this.isMobile = window.innerWidth < 1024
    },
    isCardEmpty (card) {
      return !card.recipient.name && !card.recipient.phone &&
            !card.amount && (card.anonymous || !card.senderSign)
    },
    remove (card, index) {
      this.items.splice(index, 1)
      this.$localStorage.set('order', this.items)
    },
    makeEmptyCard () {
      return {
        recipient: {
          name: null,
          phone: null,
          email: null
        },
        design: this.designs.length ? this.designs[0].path : null,
        amount: null,
        text: null,
        senderSign: null,
        sendingDate: this.minDate,
        sendingHour: 12,
        anonymous: false,
        sendingTimezone: 'Europe/Minsk'
      }
    },
    changeCity (e) {
      this.cityId = e.target.value
      this.$v.cityId.$touch()
    },
    toggleAnonymous () {
      this.card.senderSign = ''
    },
    addCard () {
      if (this.haveActiveCard && this.$v.card.$invalid) {
        this.$v.card.$touch()
      }
      if (this.haveActiveCard) {
        if (!this.$v.card.$error) {
          const sendingDate = new Date(this.card.sendingDate).setHours(this.card.sendingHour)
          this.card.sendingDate = new Date(this.card.sendingDate)
          this.card.sendingDateTime = new Date(sendingDate).toISOString()
          this.card = this.makeEmptyCard()
          this.items.push(this.card)
          this.$v.card.$reset()
          this.anonymous = false
          this.$nextTick(function () {
            this.$v.card.recipient.phone.$reset()
          })
          this.scrollToForm()
        } else {
          this.scrollToFirtsInvalid()
        }
      } else {
        this.items.push(this.card)
        this.$nextTick(function () {
          this.$v.card.recipient.phone.$reset()
        })
        this.scrollToForm()
      }
    },
    editCard (card) {
      if (this.haveActiveCard) {
        if (this.isCardFormEmpty) {
          this.items.splice(this.items.indexOf(this.card), 1)

          // Dirty hack with replace for masked input
          const phone = card.recipient.phone.replace(/\D/g, '')
          card.recipient.phone = phone.substr(1, phone.length)

          this.card = card
          this.$v.card.$reset()
        } else if (this.$v.card.$invalid) {
          this.$v.card.$touch()
          this.scrollToFirtsInvalid()
        } else {
          // let sendingDate = new Date(this.card.sendingDate).setHours(this.card.sendingHour)
          // this.card.sendingDateTime = new Date(sendingDate).toISOString()
          card.sendingDate = card.sendingDateTime
          // Dirty hack with replace for masked input
          const phone = card.recipient.phone.replace(/\D/g, '')
          card.recipient.phone = phone.substr(1, phone.length)

          this.card = card
          this.scrollToForm()
        }
      } else {
        // Dirty hack with replace for masked input
        const phone = card.recipient.phone.replace(/\D/g, '')
        card.recipient.phone = phone.substr(1, phone.length)
        card.sendingDate = card.sendingDateTime
        this.card = card
        this.scrollToForm()
      }
    },
    closeSendyModal () {
      this.$modal.hide('pay-by-sendy')
      clearInterval(this.sendyTimerID)
    },
    checkSendyOrderStatus (orderNumber) {
      axios.get(`${apiUrl}/order/${orderNumber}/status/`)
        .then(({ data }) => {
          const { status } = data
          this.sendyOrderStatus = status
          if (status === 'paid') {
            clearInterval(this.sendyTimerID)
            this.$router.push({ name: 'VirtualResult' })
          }
        })
    },
    sendOrder () {
      const { paymentType } = this
      this.$v.cityId.$touch()
      if (this.isCardFormEmpty) {
        this.$v.card.$reset()
      }
      if (this.haveActiveCard && !this.isCardFormEmpty && this.$v.card.$invalid) {
        this.$v.card.$touch()
        this.scrollToFirtsInvalid()
        return
      }
      if (this.$v.customer.$invalid) {
        this.$v.customer.$touch()
      }
      if (!this.$v.customer.$error) {
        if (!this.$v.card.$error) {
          for (const card of this.nonEmptyCards) {
            card.sendingDateTime = dateToTimezone(new Date(card.sendingDate), card.sendingTimezone, card.sendingHour)
          }
          const order = {
            items: this.nonEmptyCards,
            buyer: this.buyer,
            cityId: this.cityId,
            total: this.total,
            type: 'virtual'
          }
          this.$localStorage.set('order', order)
          // after that delete card.sendingTimezone from cards
          const orderToSend = JSON.parse(JSON.stringify(order))
          orderToSend.items.forEach(x => {
            delete x.sendingTimezone
          })
          delete orderToSend.total
          delete orderToSend.type
          this.pending = true
          orderToSend.sendReceiptBySms = this.sendReceiptBySms
          orderToSend.paymentType = paymentType
          axios.post(`${apiUrl}/order/virtual`, orderToSend)
            .then(({ data }) => {
              this.$localStorage.set('orderId', data.orderId)
              if (paymentType !== 'sendy') {
                window.location.replace(data.redirect)
              } else {
                this.sendyQRData = data.qrCode
                this.$modal.show('pay-by-sendy')
                this.sendyTimerID = setInterval(this.checkSendyOrderStatus, 2500, data.orderId)
              }
            })
            .catch(({ response }) => {
              this.pending = false
              if (response.status === 500) {
                this.$router.push({ name: 'ModalError', query: { code: 1 } })
              }
            })
        } else {
          this.scrollToFirtsInvalid()
        }
      } else {
        this.scrollToFirtsInvalid()
      }
    },
    scrollToForm () {
      if (document.querySelector('.card-form')) document.querySelector('.card-form').scrollIntoView({ behavior: 'smooth' })
    },
    scrollToFirtsInvalid () {
      this.$nextTick(function () {
        const invalid = document.querySelectorAll('.invalid')[0]
        if (invalid) {
          window.scrollTo({ top: getTopPosition(invalid), behavior: 'smooth' })
        }
      })
    }
  }
}
</script>

<style src="@/components/Cards.css" scoped/>

<style>
.buy-buttons {
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 10px 0px;
  align-content: center;
  margin: 0 auto;
}

.buy-buttons > .buy {
  margin: 5px 5px;
}

@media screen and (max-width: 1023px) {
  .buy-buttons {
    flex-direction: column;
    padding: 0px 10px;
    max-width: 365px;
  }
}

.message-modal {
  position: relative;
  margin: auto;
  max-width: 450px;
  text-align: center;
  padding-top: 10px;
}

.message-modal {
  color: rgba(0, 0, 0, .8);
  font-size: 18px;
  line-height: normal;
}

.result {
  position: relative;
  font: 500 14px/1 Museo, sans-serif;
  width: 600px;
  margin: auto;
}

.top {
  padding: 30px 33px 30px;
  border-bottom: 1px solid rgba(139, 139, 139, .5);
}

.go-back-modal {
  position: absolute;
  top: 8px;
  right: 15px;
  width: 20px;
  height: 20px;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  padding: 5px;
  opacity: .4;
}

.go-back-modal:hover {
  opacity: 1;
}

.go-back-modal::before,
.go-back-modal::after {
  content: '';
  display: block;
  background: #000;
  height: 3px;
  width: 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  transform-origin: center;
}

.go-back-modal::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.title {
  font: 700 60px Bebas, sans-serif;
  line-height: 50px;
  margin-bottom: 10px;
}

.message {
  color: rgba(0, 0, 0, .8);
  font-size: 18px;
  line-height: normal;
  margin: 0;
}

.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 33px 30px;
  background-color: #ededed;
  box-shadow: inset 0 4px 12px 0 rgba(0, 0, 0, 0.05);
}

.confirm {
  width: 360px;
  border-radius: 4px;
  text-transform: uppercase;
  line-height: 56px;
  font-size: 15px;
  font-weight: bold;
}

.confirm {
  background: #bc9665;
  color: #fff;
  margin-bottom: 15px;
}

.confirm:hover,
.confirm:focus {
  background-color: #b68b55;
}

.contact {
  color: rgba(0, 0, 0, .3);
  text-align: center;
  font-weight: 700;
}

.support {
  font-size: 11px;
  text-transform: uppercase;
  margin-bottom: 3px;
}

/*=============================================>>>>>
= Mobile =
===============================================>>>>>*/

@media screen and (max-width: 1023px) {
  .vm--modal{
    width: 100% !important;
    height: 100% !important;
    top: 0px !important;
    left: 0px !important;
    z-index: 999 !important;
  }
  .result {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .top {
    background-color: #f6f6f7;
    border: none;
    padding: 30px 33px 30px;
  }

  .go-back-modal {
    background-color: #fff;
    box-shadow: 2.8px 2.8px 14px 0 rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    overflow: hidden;
    padding: 17px;
    position: fixed;
    z-index: 2;
    top: 12px;
    right: 8px;
    opacity: .7;
  }

  .go-back-modal::before,
  .go-back-modal::after {
    width: 20px;
  }

  .title {
    font-size: 60px;
    margin-bottom: 5px;
  }

  .bottom {
    margin-top: auto;
    padding: 36px 33px;
  }

  .confirm {
    width: 100%;
    max-width: 330px;
    font-size: 14px;
    line-height: 48px;
  }

  .contact {
    color: rgba(0, 0, 0, .6);
  }

  .support {
    font-size: 12px;
  }
}
</style>
